
// HTML 5 VIDEO
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.js-accordion-toggle-price').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        const content = this.nextElementSibling;
        content.classList.toggle('open');
      });
    });
  });
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('.js-accordion-toggle').forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        const content = this.nextElementSibling;
        content.classList.toggle('open');
      });
    });
  });
document.addEventListener("DOMContentLoaded", function () {
    const accordionHeader = document.querySelector(".mobile-accordion-header");
    const closeButton = document.querySelector(".mobile-filter-close");
    const accordion = document.querySelector(".mobile-accordion");

    // Only continue if all elements exist
    if (accordionHeader && closeButton && accordion) {
      function updateCloseButtonVisibility() {
        if (accordion.classList.contains("open")) {
          closeButton.style.display = "block";
        } else {
          closeButton.style.display = "none";
        }
      }

      // Toggle accordion and update close button
      accordionHeader.addEventListener("click", function () {
        accordion.classList.toggle("open");
        updateCloseButtonVisibility();
      });

      // Close accordion and hide close button
      closeButton.addEventListener("click", function () {
        accordion.classList.remove("open");
        updateCloseButtonVisibility();
      });

      // Initialize (make sure close is hidden on load)
      updateCloseButtonVisibility();
    } else {
      console.warn("Accordion elements not found in the DOM.");
    }
  });

function toggleSortAccordion(header) {
  const icon = header.querySelector('.icon');
  const parent = header.closest('.accordion-sort');
  const content = parent.querySelector('.accordion-sort-content');

  const isOpen = content.classList.contains('open');

  if (isOpen) {
    // Closing
    content.style.maxHeight = content.scrollHeight + 'px'; // set current height
    content.offsetHeight; // force reflow
    content.style.maxHeight = '0px'; // trigger collapse
    icon && (icon.textContent = '+');
    content.classList.remove('open');

    content.addEventListener('transitionend', function handler() {
      content.style.maxHeight = ''; // clean inline style
      content.removeEventListener('transitionend', handler);
    });

  } else {
    // Opening
    content.classList.add('open');
    content.style.maxHeight = '0px'; // reset to 0
    icon && (icon.textContent = '−');

    requestAnimationFrame(() => {
      content.style.maxHeight = content.scrollHeight + 'px'; // expand
    });

    content.addEventListener('transitionend', function handler() {
      content.style.maxHeight = 'none'; // allow auto height
      content.removeEventListener('transitionend', handler);
    });
  }
}


  function toggleAccordion(header) {
    const icon = header.querySelector('.icon');
    const content = header.nextElementSibling;

    if (content.classList.contains('open')) {
      // Closing
      content.style.maxHeight = content.scrollHeight + 'px'; // Set to current height first
      requestAnimationFrame(() => {
        content.style.maxHeight = '0px';
      });
      icon.textContent = '+';
      content.classList.remove('open');
    } else {
      // Opening
      content.style.maxHeight = content.scrollHeight + 'px';
      icon.textContent = '−';
      content.classList.add('open');

      // Optional: After animation, remove max-height so it behaves like max-content
      content.addEventListener('transitionend', function handler() {
        if (content.classList.contains('open')) {
          content.style.maxHeight = 'none';
        }
        content.removeEventListener('transitionend', handler);
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    const resetBtn = document.getElementById("ResetFilters");
    const form = document.getElementById("MobileFiltersForm");

    if (resetBtn && form) {
      resetBtn.addEventListener("click", function () {
        // Reset checkboxes, radio buttons
        const inputs = form.querySelectorAll('input[type="checkbox"], input[type="radio"]');
        inputs.forEach(input => {
          if (!input.disabled) {
            input.checked = false;
          }
        });

        // Reset text, number inputs (e.g. price range)
        const numberInputs = form.querySelectorAll('input[type="number"], input[type="text"]');
        numberInputs.forEach(input => {
          if (!input.disabled) {
            input.value = '';
          }
        });

        // Optional: reset select dropdowns if any
        const selects = form.querySelectorAll('select');
        selects.forEach(select => {
          select.selectedIndex = 0;
        });

        // Optional: if you want to auto-submit the form after reset
        // form.submit();
      });
    }
  });

/** 
$(document).ready(function(){
    $('.slick-slider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      autoplay: true,
      autoplaySpeed: 3000,
       arrows: false,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
});
$(document).ready(function() {
    $('.review-slider').slick({
        // dots: true,
        autoplay: false,
        autoplaySpeed: 2000,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true, // 
        prevArrow: '<button type="button" class="slick-prev custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0635/3705/3743/files/icon_arrow.png?v=1751370762" alt="Previous"></button>',
        nextArrow: '<button type="button" class="slick-next custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0635/3705/3743/files/icon_arrow_1.png?v=1751370763" alt="Next"></button>',
        responsive: [{
            breakpoint: 1199,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
                // centerMode: true,

            }

        }, {
            breakpoint: 1100,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 2,
                dots: false,
                infinite: true,

            }


        }, {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                dots: false,
                infinite: true,
                
            }
        }, {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: false,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 2000,
            }
        }]
    });
});
$(document).ready(function() {
    $('.tabslider').slick({
        dots: true,
        arrows: false, // Use 'arrows' instead of 'nav'
        autoplay: true,
        autoplaySpeed: 5000,
        infinite: true,
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1199,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 1100,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
});
**/
$('.html5-video-trigger').click(function(){
    var video = $("#"+$(this).attr('data-video'));
    video = video.get(0);
    video.pause();
    if ($(this).hasClass('paused')) {
        video.play();
        $('.html5-video-trigger').removeClass('paused');
    } else {
        video.pause();
        $('.html5-video-trigger').addClass('paused');
    }
    $(this).hide();
    $(this).siblings('.html5-video-trigger').show();
});

$('.pattern').on('click', '.homepage-sidebar-trigger a', function(env){
    env.preventDefault();
    var navTarget = $(this).parents('li').attr('data-trigger');
    $('#shopify-section-homepage-sidebar ul').hide();
    $('#'+navTarget).show();
    $('li.homepage-sidebar-trigger').removeClass('active-sidebar');
    
    $('li[data-trigger="'+navTarget+'"]').addClass('active-sidebar');
})

$('.sidebar-container-trigger').on('click', 'a.open-submegamenu', function(env){
    env.preventDefault();
    //remove all other element state
    $('.sidebar-container-trigger li').removeClass('active');

    var navTarget = '#header-phantom .'+$(this).attr('data-trigger');
    $(this).parents('.sticked-sidebar').addClass('open-submegamenu-activated')
    $(this).parents('li.list-menu-sidebar').addClass('active');
    console.log($(navTarget));
    
    if (!$(this).hasClass('megamun-inserted')) {
        $(navTarget).insertAfter($(this));
        $(this).addClass('megamun-inserted')
    }
    var elementWidth = $('body').width() - 250;
    $('.linklist-groupping').css('width', elementWidth+'px');
})


$("#playyoutube").on("click", (function (t) {
    $("#youtube-video")[0].src += "&autoplay=1", $(".tp-parallax-wrap").fadeOut(600, "linear", (function () {
        $(".youtube-still").addClass("playing")
    })), t.preventDefault()
}));

// FOR PARALLAX SO THAT IT WILL NOT BREAK WHEN RESIZE AND LOAD
// var timer;
// $(window).bind('resize', function() {
//     clearTimeout(timer);
//     timer = setTimeout(function() { $(window).resize(); }, 250);
// });
// var timer;
// $(window).bind('load', function() {
//     clearTimeout(timer);
//     timer = setTimeout(function() { $(window).load(); }, 250);
// });

// Navigation
function displayChildMenu(src, el){
    var target = $(".display_"+src);
    if (target.length != 0) {
        var trigger = $(".trigger_"+src);
        $(el).parents('li').siblings().removeClass('activated');
        trigger.addClass('activated');
        //console.log(target.length);

        $(el).parents('.content').find('.linklist-groupping').removeClass('visible');
        target.addClass('visible');
        return false;
    }
}
$('.heading-sub-menu').click(function(){
    $('.content-submenu').removeClass('activated');
    $(this).parents('.content-submenu').addClass('activated');
    //$('.sticked-sidebar').addClass('open-submegamenu-activated');
});

 
// PRODUCTS PAGE
$('.trigger-delivery-info').click(function(){
    $(this).toggleClass('active');
    var target = $(this).attr('data-target');

    $('.delivery-info.'+target).toggleClass('hide');
    $('.delivery-info:not(.'+target+')').addClass('hide');
    $('.trigger-delivery-info').not(this).removeClass('active');
});


// Assembly services on every pdp
$(document).on("click", "#productAddAssembly", function() {
    var y = $('.productaddassembly-text'),
        S = $('#form-productAddAssembly'),
        U = $('#cart-product-assembly'),
        id = U.attr('data-key');
    if (U.hasClass('in-cart')) {
        return $.ajax({
            type: "POST",
            url: "/cart/change.js",
            data: "quantity="+0+"&id="+id,
            dataType: "json",
            beforeSend: function() {
                $(".product-assembly-msg").show();
                $(".product-assembly-msg").text("REMOVING...");
            },
            success: function(E) {
                $(".product-assembly-msg").text("REMOVED");
                setTimeout(function(){ $(".product-assembly-msg").hide() }, 1000);
                U.removeClass('in-cart');
            },
            error: function(E) {
                console.log(E);
            }
        })
    } else {
        return $.ajax({
            type: "POST",
            url: "/cart/add.js",
            async: !0,
            cache: !1,
            data: S.serialize(),
            dataType: "json",
            beforeSend: function() {
                $(".product-assembly-msg").show();
                $(".product-assembly-msg").text("ADDING...");
            },
            complete: function() {
                $(".product-assembly-msg").text("ADDED");
                U.prop('checked', true);
                U.addClass('in-cart');
            },
            error: function(T) {
                console.log(T)
            },
            success: function(T) {
                U.attr('data-key', T.key)
            }
        }).done(function() {}), !1
    }
})


$(".trg-d").on('click', function(ev) {
    ev.preventDefault();
    $('.check-result-container').hide();
    $('.delivery-pickup-input').show();
    $('#postcode1').val('');
})

$('.scroll-to').click(function(ev){
    ev.preventDefault();
    var target = $(this).attr('data-target');
    var space = parseInt($(this).attr('data-top'));
    $(this).parents('li').siblings().removeClass('active');
    $(this).parents('li').addClass('active');
    $('html, body').animate({
        scrollTop: $(target).offset().top - space
    }, 1500)
});

$('.open-search-mob').click(function(ev){
    ev.preventDefault();
    console.log('clicked');
    $('.mobile-nav-item.mobile-nav-search').slideToggle('fast')
})
$(document).ready(function () {
  // Use a mutation observer or interval to detect the display state change
  setInterval(function () {
    if ($('.check-result-container').css('display') === 'block') {
      $('.input-group-container.calculate-form').hide();
    } else {
      $('.input-group-container.calculate-form').show();
    }
  }, 300); // check every 300ms
});
